module.exports = __webpack_public_path__ + "img/English.00a1acba.webp";